module.exports = __webpack_public_path__ + "static/media/complete-react-app-deploy-or-host-in-firebase.cdf9ebcf.jpg";